var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "detail-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "16px",
              "font-weight": "bold",
              color: "#333"
            }
          },
          [
            _vm._v(
              _vm._s(_vm.childData.areaName) +
                " " +
                _vm._s(
                  _vm.childData.areaName !== _vm.childData.areaGroupName
                    ? _vm.childData.areaGroupName
                    : ""
                ) +
                " " +
                _vm._s(_vm.childData.buildingName) +
                " " +
                _vm._s(_vm.childData.unintName) +
                " " +
                _vm._s(_vm.childData.adCode)
            )
          ]
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "information" },
      [
        _c(
          "el-col",
          {
            staticStyle: { "margin-bottom": "10px", "padding-top": "10px" },
            attrs: { span: 24 }
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("基础信息")
            ])
          ]
        ),
        _c(
          "el-form",
          {
            ref: "dataForm",
            attrs: { "label-position": "right", "label-width": "130px" }
          },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.advCode") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.adCode))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.buildingFloor") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.floor))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.userState") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.adStatusName))])]
                )
              ],
              1
            )
          ],
          1
        ),
        _c("el-col", { attrs: { span: 24 } }, [_c("span", [_vm._v("备注")])]),
        _c("el-input", {
          staticStyle: { width: "880px", "margin-top": "1vw" },
          attrs: {
            disabled: "",
            maxlength: "100",
            type: "textarea",
            autosize: { minRows: 3, maxRows: 5 }
          },
          model: {
            value: _vm.childData.adRemark,
            callback: function($$v) {
              _vm.$set(_vm.childData, "adRemark", $$v)
            },
            expression: "childData.adRemark"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }